import React from "react";
import { Link } from "react-router-dom";
import { useListPeyments } from "./Hooks";
import Paginate from "../../Components/Paginate";
import Loading from "../../Components/Loading";
import { ToDateJalali } from "../../Utils/functions";
const List = () => {
  const { loading, data } = useListPeyments();
  const renderModel = (model) => {
    switch (model) {
      case "Plan":
        return "خرید اشتراک";
      case "Ads":
        return "ثبت آگهی";
      case "AdsOption":
        return "خرید امکانات آگهی";
      default:
        return "-"
    }
    return {};
  };
  const renderstatus = (status) => {
    switch (status) {
      case "waittopey":
      case "abandoned":
        return {
          title: "پرداخت رها شده",
          status: "process",
          details: false,
        };
      case "success":
        return {
          title: "پرداخت موفق",
          details: true,
          status: "success",
        };
      case "error":
        return {
          title: "خطا در پرداخت",
          details: true,
          status: "error",
        };
    }
    return {};
  };
  const renderBody = () => {
    console.log("00..00");
    if (loading) {
      return (
        <div className="row">
          <Loading count={2} col={12} height={"350px"} />
        </div>
      );
    } else {
      if (data.data.length == 0) {
        return (
          <div className="empty">
            <img src={require("../../Assets/images/empty.png")} />
            <p className="fs-12 mt-2 fw-500 text-center sad">
              تا کنون پرداختی نداشته اید
            </p>
          </div>
        );
      } else {
        return (
          <table className="table">
            <thead>
              <tr>
                <th className="d-lg-table-cell d-lg-table-cell d-none">
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">کد</p>
                </th>
                <th className="d-lg-table-cell d-lg-table-cell d-none">
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">
                    مبلغ پرداختی
                  </p>
                </th>

                <th>
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">وضعیت</p>
                </th>
                <th>
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">نوع</p>
                </th>
                <th>
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">تاریخ</p>
                </th>
                <th>
                  <p className="fs-12 text-blue mb-0 text-center fw-semi-normal">
                    جزيیات
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((item, count) => {
                return (
                  <tr key={count}>
                    <td className=" d-lg-table-cell ">
                      <span className="fs-12 text-blue">
                        {item.local_trackingcode}
                      </span>
                    </td>
                    <td className=" d-lg-table-cell ">
                      <p className="fs-12 text-blue mb-0">{item.total_price}</p>
                    </td>
                    <td>
                      <p className="fs-12 text-blue mb-0">
                        <span className={`${renderstatus(item.status)["status"]} ml-5`} >
                        </span>
                        {renderstatus(item.status)["title"]}
                      </p>
                    </td>
                    <td>
                      <p className="fs-12 text-blue mb-0">
                        <span >
                          {renderModel(item.model_order)}
                        </span>
                      </p>
                    </td>
                    <td>
                      <p className="fs-12 text-blue mb-0">
                        {ToDateJalali(item.created_at)}
                      </p>
                    </td>
                    <td className="btn-td text-center">
                      <div className="actions">
                        <Link
                          style={
                            !renderstatus(item.status)["details"]
                              ? { pointerEvents: "none", opacity: '0.7' }
                              : {}
                          }
                          to={
                            renderstatus(item.status)["details"]
                              ? `${item.id}`
                              : "#"
                          }
                          className="btn-modal disabled-link"
                          data-type="show">
                          مشاهده
                        </Link>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        );
        return;
      }
    }
  };
  return (
    <div className=" ads-list-wrapper row overflow-auto mt-3 mb-3">
      {renderBody()}
      <Paginate
        data={data}
        loading={loading}
        filters={[]}
        style={{ marginTop: "10px" }}
      />
    </div>
  );
};

export default List;
